import React from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading} from "../Boilerplate/deferLoaderHoc";
import {getBid} from "../../actions/bids";

const AddendumCount = ({ addendums }) => (
  <div>
    <strong>Addenda Count: {addendums}</strong>
  </div>
);

export default compose(
  connect(
    (state, props) => {
      const { bidId } = props;
      if (!state.view.data[bidId]) return { loading: true };
      return {
        addendums: (state.view.data[bidId].resource || {}).addendums
      };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getBid(props.bidId))
    })
  ),
  withLoading
)(AddendumCount);



// WEBPACK FOOTER //
// ./src/components/Bids/AddendumCount.js